import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function AdminPowerCard({ onChange }) {
  const [users, setUsers] = useState([]);
  const load = async () => {
    setUsers((await api.get("/admin/technicians", { params: { role: "tecnico" } })).data);
  };
  useEffect(() => { load().catch(() => {}); }, []);
  const toggle = async (u, on) => {
    try {
      await api.post(`/admin/users/${u.id}/admin-power`, { enabled: on });
      toast.success(on ? `${u.name} ora ha anche i poteri di amministratore` : `Poteri di amministratore tolti a ${u.name}`);
      load();
      onChange?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-2xl border bg-white p-4" data-testid="admin-power-card">
      <p className="flex items-center gap-2 font-semibold"><ShieldCheck className="h-4 w-4 text-[#61a229]" />Collega un utente all'amministratore</p>
      <p className="mb-3 text-xs text-slate-500">L'utente mantiene il suo profilo (timbrature, agenda, assegnazioni) e in più ottiene tutti i poteri dell'amministratore.</p>
      <div className="divide-y">
        {users.map((u, i) => (
          <label key={u.id} className="flex items-center justify-between gap-3 py-2 text-sm">
            <span><b>{u.name}</b> <span className="text-xs text-slate-500">{u.role === "responsabile" ? "Responsabile" : "Tecnico"}</span></span>
            <Switch checked={!!u.admin_power} onCheckedChange={(v) => toggle(u, v)} data-testid={`admin-power-switch-${i}`} />
          </label>
        ))}
        {!users.length && <p className="py-2 text-sm text-slate-500">Nessun utente disponibile.</p>}
      </div>
    </div>
  );
}
